import { useEffect } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import Button from "../common/Button";
import Input from "../common/Input";
import { settingsService } from "../../services/settings";
import toast from "react-hot-toast";
import { Save } from "lucide-react";

const EmailSettings = () => {
  const queryClient = useQueryClient();
  const { data: settings } = useQuery({
    queryKey: ["settings"],
    queryFn: settingsService.get,
  });
  const { register, handleSubmit, reset } = useForm();
  const mutation = useMutation({
    mutationFn: (data) => settingsService.update({ emailSettings: data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["settings"] });
      toast.success("Email settings saved");
    },
  });

  useEffect(() => {
    if (settings?.emailSettings) reset(settings.emailSettings);
  }, [settings, reset]);

  const onSubmit = (data) => mutation.mutate(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-5 max-w-lg">
      <Input label="SMTP Host" {...register("smtpHost")} placeholder="smtp.gmail.com" />
      <Input label="SMTP Port" type="number" {...register("smtpPort")} placeholder="587" />
      <Input label="SMTP User" {...register("smtpUser")} placeholder="your@email.com" />
      <Input label="SMTP Password" type="password" {...register("smtpPass")} />
      <Input label="From Email" {...register("fromEmail")} placeholder="noreply@company.com" />
      <Button type="submit" disabled={mutation.isPending}>
        <Save className="w-4 h-4 mr-1.5" />
        {mutation.isPending ? "Saving..." : "Save Changes"}
      </Button>
    </form>
  );
};

export default EmailSettings;
